<template>
  <div class="gerenciamento-menu">
    <g-card class="card-gerenciamento-menu" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Menu </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza" altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            />

            <g-button
            class="plus-button"
            corIcone="#FCB315"
            cor="#4F2C19"
            altura="35px"
            largura="45px"
            icone="pi pi-plus"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            />

            <g-button
            class="buscar-button-header-filtro"
            largura="150px" icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="gerenciamento-menu-conteudo espacamento-filtros">            
          <div class="filtro-nome-menu">
            <div class="titulo-conteudo-filtros"> Menu </div>
            <PInputText class="menu-input input-label" placeholder="Insira o nome do menu"/>
          </div>
          
          <div class="filtro-vinculado-menu">
            <div class="titulo-conteudo-filtros"> Vinculado ao menu </div>
            <PDropDown class="vinculado-input input-label" placeholder="Selecione"/>
          </div>

          <div class="filtro-origem">
            <div class="titulo-conteudo-filtros"> Origem </div>
            <PDropDown class="origem-input input-label" placeholder="Selecione"/>
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    
    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo=""
      >
      </g-data-table>
    </g-card>
  </div>
</template>

<script>
import GerenciamentoMenu from "./GerenciamentoMenu.js";
export default GerenciamentoMenu;
</script>

<style scoped>

@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-menu-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 20em));
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
}
.filtro-nome-menu { grid-area: 1 / 1 / 2 / 2; }
.filtro-vinculado-menu { grid-area: 1 / 2 / 2 / 3; }
.filtro-origem { grid-area: 2 / 1 / 3 / 2; }
}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
.gerenciamento-menu-conteudo {
  grid-template-columns: repeat(3, minmax(4em, 20em));
  grid-template-rows: auto;
}
.filtro-origem { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width:1281px) { 
.gerenciamento-menu-conteudo {
  grid-template-columns: repeat(3, minmax(4em, 20em)) auto;
}   
}
</style>
